export default "__VITE_ASSET__DDTOtOjp__"